module.exports = __webpack_public_path__ + "static/media/easy-translator-logo-color.cdb65d72.svg";